import React from 'react';
import PropTypes from 'prop-types';

import Chip from '@mui/material/Chip';
import {styled} from '@mui/system';

import GlobalContext from '../../helpers/context';


const StyledChip = styled(Chip)(({ theme }) =>({
    marginLeft: 5,
    backgroundColor: '#64dd17',
    fontWeight: theme.custom.font.bold,
    textTransform: 'lowercase'
}));


class HotKeyChip extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        if (this.context.showHotKeyHelp()){
            return (
                <GlobalContext.Consumer>{() => (
                    <StyledChip size="small" label={this.props.hotKey} />
                )}
                </GlobalContext.Consumer>
            );
        }
    }
}

HotKeyChip.contextType = GlobalContext;

HotKeyChip.propTypes = {
    hotKey: PropTypes.string
};

export default HotKeyChip;
